module.exports = __webpack_public_path__ + "static/media/rules-step-03.2ce5111f.png";